<template>
  <div class="map-wizard" :class="bemFacets">
    <div class="map-wizard__navigation">
      <slot name="navigation" />
    </div>
    <div class="map-wizard__configurator">
      <slot name="step" />
    </div>
    <div class="map-wizard__viewer">
      <slot name="map" />
    </div>
  </div>
</template>

<script>
  import bemMixin from '@/assets/js/mixin/bem'

  export default {
    mixins: [bemMixin('map-wizard')],
    props: {},
  }
</script>

<style lang="scss" src="./_map-wizard.scss" />
